import { CorePluginService } from './core-plugin.service';
import { PluginInitializerService } from 'core-client/api';

export function corePluginInitializerFactory(
  corePluginService: CorePluginService,
  configurationService: PluginInitializerService
): () => Promise<void> {
  return () =>
    new Promise<void>((resolve) => {
      const init = async () => {
        await corePluginService.setup();
      };

      configurationService.setup('corePlugin', init, resolve);
    });
}
